import { IconMetaData, IconThemeType } from "./types";
import { iconNames as webIconNames } from "../../themes/web/assets/icons/icons-list/iconNames";
import { iconNames as responsiveIconNames } from "../../themes/responsive/assets/icons/icons-list/iconNames";

export const NS_ICON_REGISTRY = "trumpf.ux.iconRegistry";
export const AVAILABLE_THEMES = ["web", "responsive"];

export const AVAILABLE_ICONS: Record<IconThemeType, IconMetaData[]> = {
    // @ts-expect-error Check for typing
    web: webIconNames,
    // @ts-expect-error Check for typing
    responsive: responsiveIconNames
};
